// Source: https://play.tailwindcss.com/EJMdSimPRW?size=810x720&file=css

// Used by <ui-input>
const calendar = {
  ".ds-calendar": { "@apply ds-w-full ds-text-center ds-text-sm ds-min-h-[200px]": true },
  ".ds-calendar .ds-disabled": { "@apply ds-text-tertiary-lightgrey": true },
  ".ds-calendar [tabindex].ds-disabled": {
    "@apply ds-cursor-not-allowed": true,
  },
  ".ds-calendar td": { "@apply ds-min-w-[1.75rem] ds-h-xl": true },
  ".ds-calendar [tabindex]": {
    "@apply ds-outline-none ds-cursor-pointer": true,
  },
  ".ds-calendar tr.ds-selected td,\n.ds-calendar td.ds-selected": {
    "@apply !ds-bg-primary-blue !ds-text-primary-white": true,
  },
  ".ds-calendar [tabindex]:focus td.ds-disabled": {
    "@apply ds-text-primary-black-50": true,
  },
  ".ds-calendar [tabindex]:not(.ds-disabled):hover,\n.ds-calendar [tabindex]:not(.ds-disabled):hover td": {
    "@apply ds-bg-background-grey": true,
  },
  ".ds-calendar [tabindex]:not(.ds-disabled):focus,\n.ds-calendar [tabindex]:not(.ds-disabled):focus td": {
    "@apply ds-bg-primary-blue-30 ds-text-primary-black": true,
  },
  ".ds-calendar [tabindex]:focus td:first-child,\n.ds-calendar [tabindex]:hover td:first-child,\n.ds-calendar tr.ds-selected td:first-child":
    {
      "@apply ds-rounded-l-full": true,
    },
  ".ds-calendar [tabindex]:focus td:last-child,\n.ds-calendar [tabindex]:hover td:last-child,\n.ds-calendar tr.ds-selected td:last-child":
    {
      "@apply ds-rounded-r-full": true,
    },
  ".ds-calendar td[tabindex]:focus,\n.ds-calendar td[tabindex]:hover,\n.ds-calendar td.ds-selected": {
    "@apply ds-rounded-full": true,
  },
};

// Used by <ui-calendar>
const day = {
  ".day": {
    width: "12.5%",
    position: "relative",
    "@apply ds-table-cell ds-text-center ds-align-middle ds-cursor-pointer ds-rounded-full": true,
  },
  ".day:after": {
    content: "''",
    display: "block",
    paddingTop: "100%",
  },
  ".day > span": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate3d(-50%, -50%, 0)",
  },
  ".day:hover": {
    "@apply ds-bg-background-grey": true,
  },
  ".day:focus": {
    "@apply ds-outline-none ds-bg-primary-blue-50": true,
  },
  ".day:active": {
    "@apply !ds-bg-primary-blue-50": true,
  },
  ".day.is-selected": {
    "@apply ds-bg-primary-blue ds-rounded-full ds-text-primary-white ds-font-bold": true,
  },
  ".day.is-disabled": {
    "@apply !ds-text-primary-gray-70 !ds-bg-transparent !ds-cursor-not-allowed ds-pointer-events-none": true,
  },
  ".day:not(.is-selected):hover": {
    "@apply ds-bg-background-grey ds-rounded-full": true,
  },
};

// Used by <ui-calendar>
const week = {
  ".week > .day + .day": {
    "@apply !ds-rounded-none": true,
  },
  ".week > .day:first-child": {
    "@apply !ds-rounded-l-full": true,
    "@apply !ds-rounded-r-none": true,
  },
  ".week > .day:last-child": {
    "@apply !ds-rounded-r-full": true,
  },
  ".week > .is-selected": {
    "@apply !ds-bg-primary-blue": true,
  },
  ".week:hover > .day:not(.is-selected)": {
    "@apply !ds-bg-background-grey": true,
  },
  ".week:active > .day:not(.is-selected)": {
    "@apply !ds-bg-primary-blue-50": true,
  },
};

// TODO (stefan): Make this global
// When exporting a Tailwind CSS to JavaScript using this tool: https://transform.tools/css-to-js
// we also need to remove the prefix (ds) before we can use it inside our config.
// This utility function solves that problem.
// We might consider turning this into a global utility if we want to use it in more components
// in the future.
const parseKeys = (source) => {
  const target = {};
  for (const sourceKey in source)
    if (typeof source[sourceKey] === "object") {
      const targetKey = sourceKey.replace(/\.ds-/g, ".").replace(/\n/, "");
      target[targetKey] = parseKeys(source[sourceKey]);
    } else target[sourceKey] = source[sourceKey];
  return target;
};

module.exports = () => ({
  ...parseKeys(calendar),
  ...day,
  ...week,
});
